import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app';

interface ModalState {
  visiblePartnerNoteModal: boolean;
  dataPartnerNoteModal: {
    id?: string;
    displayName?: string;
    code?: string;
    phoneNumber?: string;
  };
}

const initialState: ModalState = {
  visiblePartnerNoteModal: false,
  dataPartnerNoteModal: {
    id: undefined,
    displayName: undefined,
    code: undefined,
    phoneNumber: undefined,
  },
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    showPartnerNoteModal(
      state,
      action: PayloadAction<{
        id?: string;
        displayName?: string;
        code?: string;
        phoneNumber?: string;
      }>
    ) {
      state.visiblePartnerNoteModal = true;
      state.dataPartnerNoteModal = {
        ...action.payload,
      };
    },
    updatePartnerCode(
      state,
      action: PayloadAction<{
        code?: string;
      }>
    ) {
      state.dataPartnerNoteModal = {
        ...state.dataPartnerNoteModal,
        code: action.payload.code,
      };
    },
    cancelPartnerNoteModal(state) {
      state.visiblePartnerNoteModal = false;
      state.dataPartnerNoteModal = {
        id: undefined,
        displayName: undefined,
        phoneNumber: undefined,
      };
    },
  },
  extraReducers: {},
});

const { actions, reducer: modalReducer } = modalSlice;

export const {
  showPartnerNoteModal,
  cancelPartnerNoteModal,
  updatePartnerCode,
} = actions;

export default modalReducer;

export const selectModal = (state: RootState): ModalState =>
  state.modal as ModalState;
